<nb-card class="dialog-container">
    <nb-card-header>View un fichier</nb-card-header>
    <nb-card-body>
        <div class="view-content">
            <ng2-pdfjs-viewer #pdfViewer viewerId="pdfViewer" [class.view-hidden]="!fileId" ></ng2-pdfjs-viewer>

        </div>
    </nb-card-body>
</nb-card>